import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import AccountsCascader from '../../../../elements/Cascader/AccountsCascader'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import TaxTypeSelect from '../../../../elements/Select/Lines/TaxType'
import UOM from '../../../../elements/Select/UOM'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
  TwoPartThreeColFormItemLayout,
} from '../../../../modules/FormItems'
import { dateVal, findCascadersParents, strVal } from '../../../../modules/Utils'
import React, { useEffect } from 'react'

import { compose } from 'recompose'

const ReqsSelect = compose(
  withUrlFetch({
    name: 'members',
    url: `requisitions?select=_id,code`,
  }),
  withSpinning
)(CustomSelect)

function VouchersLinesForm(props) {
  const { line, voucher, lines, isConfirmed } = props
  const { getFieldDecorator, setFieldsValue, getFieldValue } = props.form

  const isCreditCard = get(voucher, 'type') === 'Credit Card'
  console.log(line, voucher)

  const unit = getFieldValue('unit') || get(voucher, 'unit', 0)
  const rate = getFieldValue('rate') || get(voucher, 'rate', 0)
  const taxRate = getFieldValue('tax.rate') || get(voucher, 'tax.rate', 0)

  let requisitions = getFieldValue('reqs._id') || get(voucher, 'reqs._id')
  requisitions = requisitions && requisitions.replace('reqs/', '')

  let order = get(voucher, 'order._id')
  order = order && order.replace('purchases/', '').replace('orders/', '')

  const [ReqLinesSelect] = useFetchSelectUrl(
    {
      name: 'requisitionsLines',
      url: `requisitions/${requisitions}/lines`,
      cache: true,
    },
    [requisitions],
    isEmpty(requisitions)
  )

  const [OrderLinesSelect] = useFetchSelectUrl(
    {
      name: 'orderLines',
      url: `orders/${order}/lines`,
      cache: true,
    },
    [order],
    isEmpty(order)
  )

  useEffect(() => {
    const net = unit * rate
    const tax = unit * taxRate
    const gross = net + tax
    setFieldsValue({
      'amount.gross': gross,
      'amount.net': net,
      'amount.tax': tax,
    })
  }, [unit, rate, taxRate])

  const { data: accounts, fetching: fetchingAccounts, fetchURL: fetchAccounts } = useFetchURL(
    `foxxapi/accounts?select=_id,name,_parent&company=${get(voucher, 'company._id')}`,
    undefined,
    undefined,
    undefined,
    true
  )

  return (
    <Form>
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="No">
            {getFieldDecorator('no', {
              initialValue: get(line, 'no') || String('0' + (lines.length + 1)).slice(-2),
              rules: rules.input,
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item {...TwoPartThreeColFormItemLayout} label="Name">
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
            })(<Input disabled={isConfirmed} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Unit">
            {getFieldDecorator('unit', {
              initialValue: get(line, 'unit'),
            })(<InputNumber disabled={isConfirmed} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="UOM">
            {getFieldDecorator('uom.code', {
              initialValue: get(line, 'uom.code'),
              rules: rules.select,
            })(<UOM disabled={isConfirmed} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Rate">
            {getFieldDecorator('rate', {
              initialValue: get(line, 'rate'),
              rules: rules.input,
            })(<InputNumber disabled={isConfirmed} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {isCreditCard && (
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Date">
              {getFieldDecorator('date', {
                initialValue: dateVal(line, 'date'),
              })(<DatePicker disabled={true} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        )}

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Don't Include in Reports">
            {getFieldDecorator('isNonPayAndLoss', {
              initialValue: get(line, 'isNonPayAndLoss'),
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Tax Type">
            {getFieldDecorator('tax.type', {
              initialValue: get(line, 'tax.type'),
              rules: rules.select,
            })(<TaxTypeSelect disabled={isConfirmed} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Tax Rate">
            {getFieldDecorator('tax.rate', {
              initialValue: get(line, 'tax.rate'),
            })(
              <Input
                type="number"
                addonBefore={<strong>{voucher.currency}</strong>}
                style={{ width: '100%' }}
                placeholder={'Tax Rate'}
                disabled={isConfirmed}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label={'Account'}>
            {getFieldDecorator('account._id', {
              initialValue: findCascadersParents(accounts, strVal(line, 'account._id') || get(line, 'accounts')),
              rules: getFieldValue('isNonPayAndLoss') !== true && rules.select,
            })(<AccountsCascader company={get(voucher, 'company._id')} placeholder={'Account'} />)}
          </Form.Item>
        </Col>
      </Row>

      {order && !isCreditCard && (
        <Row>
          <Col span={16}>
            <Form.Item {...fullWidthFormItemLayout} label="Order Lines">
              {getFieldDecorator('orderLine._id', {
                initialValue: get(line, 'orderLine._id'),
                rules: get(voucher, 'order._id') && rules.select,
              })(
                <OrderLinesSelect keyAtr={'_id'} disabled={isConfirmed} valueAtr={'name'} style={{ width: '100%' }} />
              )}
            </Form.Item>
          </Col>
        </Row>
      )}

      {!order && !isCreditCard && (
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Reqs">
              {getFieldDecorator('reqs._id', {
                initialValue: get(line, 'reqs._id'),
              })(<ReqsSelect keyAtr={'_id'} disabled={isConfirmed} valueAtr={'code'} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>

          {requisitions && (
            <Col span={16}>
              <Form.Item {...TwoPartThreeColFormItemLayout} label="Req Lines">
                {getFieldDecorator('reqLines._id', {
                  initialValue: get(line, 'reqLines._id'),
                })(
                  <ReqLinesSelect keyAtr={'_id'} disabled={isConfirmed} valueAtr={'name'} style={{ width: '100%' }} />
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}

      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Net">
            {getFieldDecorator('amount.net', {
              initialValue: get(line, 'amount.net'),
            })(<InputNumber disabled={true} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Tax">
            {getFieldDecorator('amount.tax', {
              initialValue: get(line, 'amount.tax'),
            })(<InputNumber disabled={true} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Gross">
            {getFieldDecorator('amount.gross', {
              initialValue: get(line, 'amount.gross'),
            })(<InputNumber disabled={true} style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

VouchersLinesForm.propTypes = {}
VouchersLinesForm.defaultProps = {}

export default Form.create()(VouchersLinesForm)
